<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <h2 class="text-lg mb-2 mt-5">รายงานเพื่อติดตามการดำเนินงานและการแก้ไขปัญหา</h2>
    <DataTreeTable
      :api-params="paramsComputed"
      :api-url="'household/getHouseSurveySolActReport'"
      :method-request="'POST'"
      :data-array-table="dataArrayTable"
      :key="key"
      :table-name="'report-dimension'"
      :default-sort="[{field:'_id',dir:'asc'}]"
      :custom-sort="[{column: 'head_name', relateColumn: ['head_surname']}]"
      :downloadCsv="downloadCsv"
      @downloadCsvComplete="$emit('downloadCsvComplete')"
      :downloadExcel="downloadExcel"
      @downloadExcelComplete="$emit('downloadExcelComplete')"
      reportName="รายงานเพื่อติดตามการดำเนินงานและการแก้ไขปัญหา"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch, computed } from 'vue'
import DataTreeTable from "@/components/datatable/dataTreeDataTable.vue"

export default defineComponent({
  props:{
    filter:{
        type: Object
    },
    downloadCsv:{
      type: Boolean
    },
    downloadExcel:{
      type: Boolean
    }
  },
  components:{
    DataTreeTable
  },
  setup(props) {
    const params = ref({start: '1',draw: '1',length: '10'})
    const key = ref(1)
    watch(()=>props.filter, ()=>{
      key.value++
    })
    const paramsComputed = computed(() => ({...params.value, ...props.filter}))
    var customNameMutator = (value, data, type, params, component) => {
      return `${data.head_title ? data.head_title : ""}${data.head_name ? data.head_name: ""} ${data.head_surname ? data.head_surname : ""}`
    }
    var customNameMemberMutator = (value, data, type, params, component) => {
      return `${data.memberinfo?.title ? data.memberinfo.title : ""}${data.memberinfo?.name ? data.memberinfo.name: ""} ${data.memberinfo?.surname ? data.memberinfo.surname : ""}`
    }
    var customAddressMutator = (value, data, type, params, component) => {
      return `${data.hnum ? data.hnum:""} ${data.moo?'หมู่ '+data.moo:""} ${data.village_name?data.village_name: ""} ${data.soi?'ซอย '+data.soi: ""} ${data.road?'ถนน '+data.road: ""}`
    }
    var customPlanDurationMutator = (value, data, type, params, component) => {
      if(data.plan_duration){
        if(data.plan_duration == "critical"){
          return "แผนระยะวิกฤต"
        }
        else if(data.plan_duration == "short"){
          return "แผนระยะสั้น"
        }else{
          return "แผนระยะต่อเนื่อง"
        }
      }
      else{
        return ""
      }
    }
    var customSolDes = (value, data, type, params, component) => {
      let other = data.sol_other ? ' ('+data.sol_other+')' :''
      return `${data.sol_des == 'อื่นๆ' ? data.sol_des+other : data.sol_des}`
    }
    const dataArrayTable = reactive([
      {title:"เลขที่ครัวเรือน", field:"hh_id", minWidth: 215, width: 215, resizable:true, hozAlign:"left", formatter:"textarea" },
      {title:"หัวหน้าครัวเรือน", field:"head_name", minWidth: 230, width: 230,variableHeight: true, mutator: customNameMutator, hozAlign:"left", formatter:"textarea"},
      {title:"ที่อยู่", field:"hnum", minWidth: 200, width: 200,resizable:true, formatter:"textarea", mutator: customAddressMutator},
      {title:"หมู่บ้าน", field:"village_name", minWidth: 120, width: 120,resizable:true},
      {title:"ตำบล", field:"tumbol_name", minWidth: 120, width: 120,resizable:true},
      {title:"อำเภอ", field:"amphur_name", minWidth: 120, width: 120, resizable:true},
      {title:"จังหวัด", field:"province_name", minWidth: 150, width: 150,resizable:true},
      {title:"ประเภทครัวเรือน", field:"hh_type", minWidth: 150, width: 150,resizable:true, formatter:"textarea"},
      // {title:"จำนวนครอบครัว", field:"fam_cnt", hozAlign:"left", minWidth: 80, resizable:true, formatter:
      //   function(cell, formatterParams){
      //     return cell.getValue() ? cell.getValue() : null
      //   }
      // },
      {title:"จำนวนสมาชิก", field:"member_cnt", hozAlign:"center", resizable:true, minWidth: 100, width: 100,
        formatter:function(cell, formatterParams){
          return cell.getValue() ? cell.getValue() : null
        }
      },
      {title:"ชื่อสมาชิกที่พบปัญหา", field:"memberinfo.name", hozAlign:"left", resizable:true, minWidth: 230, width: 230,formatter:"textarea", mutator: customNameMemberMutator,
      },
      {title:"มิติที่ประสบปัญหา", field:"problem_dimension", hozAlign:"left", resizable:true, minWidth: 120, width: 120,formatter:"textarea",
      },
      {title:"ปัญหาความเดือดร้อน", field:"problem", hozAlign:"left", resizable:true, minWidth: 120, width: 120,formatter:"textarea",
      },
      {title:"ระยะเวลาแผนการช่วยเหลือ", field:"plan_duration", hozAlign:"left", resizable:true, minWidth: 120, width: 120, mutator: customPlanDurationMutator,formatter:"textarea",
      },
      {title:"แนวทางการแก้ไข", field:"sol_des", hozAlign:"left", resizable:true, width: 200, minWidth: 200,formatter:"textarea", mutator: customSolDes
      },
      {title:"รายละเอียดการช่วยเหลือ", field:"sol_detail", hozAlign:"left", resizable:true, width: 200, minWidth: 200,formatter:"textarea",
        mutator: function(value, data){
          return data.sol_detail ? data.sol_detail : ''
        }
      },
      {title:"หน่วยงานที่ส่งต่อ", field:"main_org_name", hozAlign:"left", resizable:true, minWidth: 180, width: 180,formatter:"textarea",
        mutator: function(value, data){
          return data.main_org_name ? data.main_org_name : ''
        }
      },
      {title:"วันที่ติดตาม", field:"act_date", hozAlign:"center", resizable:true, minWidth: 140, width: 140,
        formatter:function(cell, formatterParams){
          if(cell.getValue()){
            const date = new Date(cell.getValue());
            const result = date.toLocaleDateString("th-TH", {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
            return result
          }
          return null
        },
        mutator: function(value, data){
          return data.act_date ? data.act_date : ''
        }
      },
      {title:"ขั้นตอน/กระบวนการช่วยเหลือ", field:"act_procedure", hozAlign:"left", resizable:true, minWidth: 150, width: 150,formatter:"textarea", formatter:"textarea",
        mutator: function(value, data){
          return data.act_procedure ? data.act_procedure : ''
        }
      },
      {title:"ผลความช่วยเหลือ", field:"act_progression", hozAlign:"left", resizable:true, minWidth: 150, width: 150,formatter:"textarea",
        mutator: function(value, data){
          return data.act_progression ? data.act_progression : ''
        }
      },
      {title:"รายละเอียดการติดตาม", field:"act_detail", hozAlign:"left", resizable:true, width: 200, width: 200,formatter:"textarea",
        mutator: function(value, data){
          return data.act_detail ? data.act_detail : ''
        }
      },
      {title:"ผู้สำรวจ/ติดตาม", field:"act_by_name", hozAlign:"left", resizable:true, minWidth: 230, width: 230, formatter:"textarea",
        mutator: function(value, data){
            return data.act_by_name ? data.act_by_name : ''
        }
      },
      {title:"ครัวเรือน TPMAP ", field:"hh_tpmap", hozAlign:"left", resizable:true, minWidth: 120, width: 120, formatter:"textarea",
        mutator: function(value, data){
            return data.hh_tpmap ? data.hh_tpmap : ''
        }
      },
      /* {//create column group
        title:"จำนวนคนที่ประสบปัญหา/ต้องการพัฒนาคุณภาพชีวิต",
        columns:[
          {title:"สุขภาพ", field:"prob_health", hozAlign:"right", width:100, hozAlign:"left", headerSort:false,  formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"ความเป็นอยู่", field:"prob_family", hozAlign:"right", width:120, hozAlign:"left", headerSort:false, formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"การศึกษา", field:"prob_education", hozAlign:"right", width:100, hozAlign:"left", headerSort:false, formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"รายได้", field:"prob_occupation", hozAlign:"right", width:100, hozAlign:"left", headerSort:false, formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"การเข้าถึงบริการรัฐ", field:"prob_accesibility", hozAlign:"right", width:155, hozAlign:"left", headerSort:false, formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
        ],
      }, */
    ])
    const countCard = reactive([
      {
        text: "จำนวนครัวเรือน",
        approve_count: 28,
        reject_count: 28,
        icon: "house",
      },
      {
        text: "จำนวนครอบครัว",
        approve_count: 28,
        reject_count: 28,
        icon: "family",
      },
      {
        text: "จำนวนสมาชิก",
        approve_count: 28,
        reject_count: 28,
        icon: "member",
      },
      {
        text: "จำนวนความเปราะบาง",
        level_0: 28,
        level_1: 28,
        level_2: 28,
        level_3: 28,
        icon: "sensitive",
      },
    ]);

    return {
      dataArrayTable,
      countCard,
      paramsComputed,
      key
    }
  }
})
</script>
<style lang="scss">
/*#tree-tabulator.tabulator{
  .tabulator-tree-level-0 [tabulator-field="household_count"],
  .tabulator-tree-level-0 [tabulator-field="family_count"],
  .tabulator-tree-level-0 [tabulator-field="member_count"],
  .tabulator-tree-level-0 [tabulator-field="sensitive_level_count"] {
    text-align: center !important;
    justify-content: center !important;
  }
}*/
.flex-1-5{
  flex: 1.5;
}
</style>

